import { createSlice } from "@reduxjs/toolkit";

import {
  getPost,
  getPosts,
  updatePost,
  clearPosts,
  updatePostToFavorites,
} from "./actions";

const initialState = () => {
  const initialData =
    typeof window !== "undefined"
      ? (window as any)?.__INITIAL_DATA__ || null
      : null;

  return {
    posts: initialData?.investmentsData || {
      data: [],
      currentPage: 1,
      perPage: 12,
      totalItems: 0,
      totalPages: 1,
      queryParams: {
        page: 1,
        limit: 12,
        search: "",
        sortBy: "createdAt",
        sortDirection: "desc",
      },
    },
    post: null,
  };
};

const investmentsSlice = createSlice({
  name: "investments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPosts.fulfilled, (state, action) => {
      state.posts = action.payload;
    });

    builder.addCase(getPost.fulfilled, (state, action) => {
      state.post = action.payload;
    });

    builder.addCase(updatePostToFavorites.fulfilled, (state, action) => {
      if (action.payload) {
        state.post = action.payload;
      }
    });

    builder.addCase(updatePost, (state, action) => {
      state.post = action.payload;
    });

    builder.addCase(clearPosts, (state) => {
      state.posts = {
        ...state.posts,
        data: [],
      };
    });
  },
});

export default investmentsSlice.reducer;
